import React from 'react';
import { isEmpty, kebabCase } from 'lodash';
import Button from '../layouts/Button';

export default function PromotionCard({ data }) {
  // console.log(data);
  const { discount, discountLabel, description, bookingLink } = data;

  const discountTitle = discount ? `${discount}% ${discountLabel}` : discountLabel;

  return (
    <div
      className="lg:w-[calc(50%-15px)] w-full lg:min-h-[271px] min-h-[240px] bg-white flex flex-col
      justify-center lg:gap-y-[38px] gap-y-[25px] lg:pt-[37px] pt-[25px] lg:pb-[48px] pb-[30px]
      lg:px-10 px-5"
    >
      <div className="flex flex-col lg:gap-y-[20px] gap-y-[15px]">
        <h3
          className="text-[23px] leading-[46px] font-roboto-condensed-bold
        uppercase"
        >
          {discountTitle}
        </h3>
        <p className="md:text-[16px] text-[15px] md:leading-[32px] leading-7 font-roboto-regular">
          {description}
        </p>
      </div>

      {isEmpty(bookingLink) || (
        <Button
          url={bookingLink.url}
          label={bookingLink.name}
          target={bookingLink.target}
          external={bookingLink.target?.includes('_blank')}
          ariaLabel={bookingLink.name}
          tagName={kebabCase(bookingLink.name)}
          variant="primaryRed"
          text="md:w-[170px] w-fit h-[45px] px-[25px] whitespace-pre text-[11px]"
        />
      )}
    </div>
  );
}
